<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :title="$t('GlobalSetObj.tips')"
      :visible.sync="showDialog"
      top="10vh"
      width="550px"
    >
      <!-- 1. 确认提示区域（点击确定前显示） -->
      <div v-if="isShowConfirm" style="font-size: 16px">
        <div style="margin-bottom: 15px">
          <span>{{ $t('GlobalSetObj.Selecionadas') }}: </span>
          <span style="color: #00A551"> {{ selectedData.length }}</span>
        </div>
        <div style="margin-bottom: 15px">
          <el-date-picker
            v-model="time1"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            type="date"
            value-format="yyyy-MM-dd"
          />
          <el-time-picker
            v-model="time2"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            style="margin-left: 20px"
            value-format="HH:mm:ss"
          />
        </div>
      </div>

      <!-- 2. 结果展示区域（接口完成后显示） -->
      <div v-if="isShowResult" style="font-size: 14px">
        <div class="flx-between" style="margin-bottom: 15px">
          <div>
            {{ $t('operationCenter.TotalQuantity') }}：<span style="color: #00A551">{{
              dataResult.totalCount
            }}</span>
          </div>
          <div>
            {{ $t('operationCenter.TheOperationSucceeded') }}：{{ dataResult.successCount }}
          </div>
          <div>
            {{ $t('mdfeTranslate.OperationFailed') }}：<span style="color: red">{{
              dataResult.failCount
            }}</span>
          </div>
        </div>
        <div v-if="dataResult.failCount > 0" style="color: red">
          {{ $t('GlobalSetObj.ReasonForFailure') }} :
        </div>
        <div style="margin-bottom: 15px; line-height: 25px; color: #00A551; letter-spacing: 1px">
          <div v-for="(reason, index) in dataResult.failReasonList" :key="index">
            {{ reason }}
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- 结果页面：只显示【关闭】按钮 -->
        <el-button
          v-if="isShowResult" size="small" type="primary"
          @click="confirmFinalAudit(1)"
        >
          {{ $t('GlobalSetObj.close') }}
        </el-button>

        <!-- 确认页面：显示【取消 + 确定】 -->
        <template v-else>
          <el-button size="small" @click="confirmFinalAudit(1)">
            {{ $t('GlobalSetObj.cancel') }}
          </el-button>
          <el-button size="small" type="primary" @click="confirmFinalAudit(2)">
            {{ $t('GlobalSetObj.confirm') }}
          </el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { updateConfirmDeadline } from '@/api/definiteResponsibilityAndPenalty';

export default {
  data() {
    return {
      time1: '',
      time2: '',
      showDialog: false,
      selectedData: [],
      isShowConfirm: true, // 显示确认提示
      isShowResult: false, // 显示结果
      dataResult: {
        totalCount: 0,
        successCount: 0,
        failCount: 0,
        failReasonList: []
      }
    };
  },
  methods: {
    confirmFinalAudit(val) {
      // 取消
      if (val === 1) {
        this.showDialog = false;
        this.resetDialog(); // 重置状态
        return;
      }

      // 确定 → 调用审核接口
      const data = {
        idList: this.selectedData.map((item) => item.id),
        confirmDeadline: `${this.time1} ${this.time2}`
      };
      if (this.time1 && this.time2) {
        console.log(data, this.time1, this.time2);
        updateConfirmDeadline(data).then((res) => {
          if (res.code === 200) {
            // 赋值结果
            this.dataResult = res.data;
            // 切换显示：隐藏确认 → 显示结果
            this.isShowConfirm = false;
            this.isShowResult = true;
            this.$emit('call-parent-search');
          }
        });
      } else {
        this.$message.error(this.$t('GlobalSetObj.selectTime'));
      }
    },

    // 打开弹窗时重置状态
    showFixTip(arg) {
      this.resetDialog();
      this.selectedData = arg;
      this.showDialog = true;
    },

    // 重置弹窗状态
    resetDialog() {
      this.isShowConfirm = true;
      this.isShowResult = false;
      this.time1 = '';
      this.time2 = '';
      this.dataResult = {
        totalCount: 0,
        successCount: 0,
        failCount: 0,
        failReasonList: []
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.dispatchName {
  width: 100%;
  height: 39px;
  border: 1px solid #dbdee5;
  padding-left: 10px;
  text-align: left;
  border-radius: 4px;
}
</style>
